import axios from "axios";
import { baseUrl } from "../util";

// Flow 43 - Transportation EoL Form Data
export const getTransportationEoL43LCA = ({
  productId,
  setData = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/transportation-eol-43-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setData(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching transportation eol 43:", error);
      setData(null);
    });
};

export const updateTransportationEoL43LCA = ({
  productId,
  system_boundary,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/transportation-eol-43-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      system_boundary: system_boundary || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Transportation EoL 43 data updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating transportation eol 43:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update transportation eol 43 data",
          icon: "error",
          button: "OK",
        });
      }
    });
};

// Flow 43 Totals
export const getTransportationEoL43Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/transportation-eol-43-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching transportation eol 43 totals:", error);
      setTotals(null);
    });
};

// Flow 43.1 - Transport for demolition/dismantling
export const getAllFlow43_1LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-43-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 43.1:", error);
      setObjects([]);
    });
};

export const addFlow43_1LCA = ({
  productId,
  means_of_transportation,
  city_of_departure,
  departure_country,
  city_of_destination,
  destination_country,
  transport_distance,
  how_much_fu_transported,
  packaging_per_fu_included,
  quantity_per_fu_used_for_transport,
  manual_emission_factor,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-43-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      means_of_transportation: means_of_transportation || null,
      city_of_departure: city_of_departure || null,
      departure_country: departure_country || null,
      city_of_destination: city_of_destination || null,
      destination_country: destination_country || null,
      transport_distance: transport_distance || 0,
      how_much_fu_transported: how_much_fu_transported || 0,
      packaging_per_fu_included: packaging_per_fu_included || null,
      quantity_per_fu_used_for_transport: quantity_per_fu_used_for_transport || 0,
      manual_emission_factor: manual_emission_factor || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 43.1 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 43.1:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 43.1 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow43_1LCA = ({
  productId,
  rowId,
  means_of_transportation,
  city_of_departure,
  departure_country,
  city_of_destination,
  destination_country,
  transport_distance,
  how_much_fu_transported,
  packaging_per_fu_included,
  quantity_per_fu_used_for_transport,
  manual_emission_factor,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-43-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      means_of_transportation: means_of_transportation || null,
      city_of_departure: city_of_departure || null,
      departure_country: departure_country || null,
      city_of_destination: city_of_destination || null,
      destination_country: destination_country || null,
      transport_distance: transport_distance || 0,
      how_much_fu_transported: how_much_fu_transported || 0,
      packaging_per_fu_included: packaging_per_fu_included || null,
      quantity_per_fu_used_for_transport: quantity_per_fu_used_for_transport || 0,
      manual_emission_factor: manual_emission_factor || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 43.1 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 43.1:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 43.1 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow43_1LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-43-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 43.1 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 43.1:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 43.1 item",
        icon: "error",
        button: "OK",
      });
    });
};

// Flow 43.2 - Waste processing
export const getAllFlow43_2LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-43-2-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 43.2:", error);
      setObjects([]);
    });
};

export const addFlow43_2LCA = ({
  productId,
  means_of_transportation,
  city_of_departure,
  departure_country,
  city_of_destination,
  destination_country,
  transport_distance,
  how_much_fu_transported,
  packaging_per_fu_included,
  quantity_per_fu_used_for_transport,
  manual_emission_factor,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-43-2-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      means_of_transportation: means_of_transportation || null,
      city_of_departure: city_of_departure || null,
      departure_country: departure_country || null,
      city_of_destination: city_of_destination || null,
      destination_country: destination_country || null,
      transport_distance: transport_distance || 0,
      how_much_fu_transported: how_much_fu_transported || 0,
      packaging_per_fu_included: packaging_per_fu_included || null,
      quantity_per_fu_used_for_transport: quantity_per_fu_used_for_transport || 0,
      manual_emission_factor: manual_emission_factor || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 43.2 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 43.2:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 43.2 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow43_2LCA = ({
  productId,
  rowId,
  means_of_transportation,
  city_of_departure,
  departure_country,
  city_of_destination,
  destination_country,
  transport_distance,
  how_much_fu_transported,
  packaging_per_fu_included,
  quantity_per_fu_used_for_transport,
  manual_emission_factor,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-43-2-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      means_of_transportation: means_of_transportation || null,
      city_of_departure: city_of_departure || null,
      departure_country: departure_country || null,
      city_of_destination: city_of_destination || null,
      destination_country: destination_country || null,
      transport_distance: transport_distance || 0,
      how_much_fu_transported: how_much_fu_transported || 0,
      packaging_per_fu_included: packaging_per_fu_included || null,
      quantity_per_fu_used_for_transport: quantity_per_fu_used_for_transport || 0,
      manual_emission_factor: manual_emission_factor || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 43.2 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 43.2:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 43.2 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow43_2LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-43-2-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 43.2 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 43.2:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 43.2 item",
        icon: "error",
        button: "OK",
      });
    });
};

// Flow 43.3 - Disposal
export const getAllFlow43_3LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-43-3-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 43.3:", error);
      setObjects([]);
    });
};

export const addFlow43_3LCA = ({
  productId,
  means_of_transportation,
  city_of_departure,
  departure_country,
  city_of_destination,
  destination_country,
  transport_distance,
  how_much_fu_transported,
  packaging_per_fu_included,
  quantity_per_fu_used_for_transport,
  manual_emission_factor,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-43-3-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      means_of_transportation: means_of_transportation || null,
      city_of_departure: city_of_departure || null,
      departure_country: departure_country || null,
      city_of_destination: city_of_destination || null,
      destination_country: destination_country || null,
      transport_distance: transport_distance || 0,
      how_much_fu_transported: how_much_fu_transported || 0,
      packaging_per_fu_included: packaging_per_fu_included || null,
      quantity_per_fu_used_for_transport: quantity_per_fu_used_for_transport || 0,
      manual_emission_factor: manual_emission_factor || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 43.3 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 43.3:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 43.3 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow43_3LCA = ({
  productId,
  rowId,
  means_of_transportation,
  city_of_departure,
  departure_country,
  city_of_destination,
  destination_country,
  transport_distance,
  how_much_fu_transported,
  packaging_per_fu_included,
  quantity_per_fu_used_for_transport,
  manual_emission_factor,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-43-3-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      means_of_transportation: means_of_transportation || null,
      city_of_departure: city_of_departure || null,
      departure_country: departure_country || null,
      city_of_destination: city_of_destination || null,
      destination_country: destination_country || null,
      transport_distance: transport_distance || 0,
      how_much_fu_transported: how_much_fu_transported || 0,
      packaging_per_fu_included: packaging_per_fu_included || null,
      quantity_per_fu_used_for_transport: quantity_per_fu_used_for_transport || 0,
      manual_emission_factor: manual_emission_factor || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 43.3 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 43.3:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 43.3 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow43_3LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-43-3-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 43.3 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 43.3:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 43.3 item",
        icon: "error",
        button: "OK",
      });
    });
};

// Flow 43.4 - Surplus materials generated in this category
export const getAllFlow43_4LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-43-4-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 43.4:", error);
      setObjects([]);
    });
};

export const addFlow43_4LCA = ({
  productId,
  surplus_resource,
  current_disposal_method,
  quantity_per_fu,
  treatment_country,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-43-4-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      surplus_resource: surplus_resource || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      treatment_country: treatment_country || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 43.4 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 43.4:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 43.4 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow43_4LCA = ({
  productId,
  rowId,
  surplus_resource,
  current_disposal_method,
  quantity_per_fu,
  treatment_country,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-43-4-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      surplus_resource: surplus_resource || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      treatment_country: treatment_country || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 43.4 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 43.4:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 43.4 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow43_4LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-43-4-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 43.4 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 43.4:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 43.4 item",
        icon: "error",
        button: "OK",
      });
    });
};

